import ForgotEmailPage from "./ForgotEmailPage";

export default ForgotEmailPage;
